// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__oM9UX","userInfo":"Menu_userInfo__Oo9dS","actions":"Menu_actions__B111P","switcher":"Menu_switcher__Lzrnh"};